import { call, put, takeEvery } from "redux-saga/effects";
import {
  SG_GET_EMPLOYEE_GROUP,
  SG_FETCH_EMPLOYEE_GROUP,
  SG_ADD_EMPLOYEE_GROUP,
  SG_EDIT_EMPLOYEE_GROUP,
  SG_DELETE_EMPLOYEE_GROUP,
  GET_EMPLOYEE_GROUP,
  FETCH_EMPLOYEE_GROUP,
  UPDATE_EMPLOYEE_GROUP,
  DELETE_EMPLOYEE_GROUP,
  PENDING_EMPLOYEE_GROUP,
  CLEAR_EMPLOYEE_GROUP,
} from "../constants/actions";

import {
  GET_EMPLOYEE_GROUP as GET_EMPLOYEE_GROUP_API,
  FETCH_EMPLOYEE_GROUP as FETCH_EMPLOYEE_GROUP_API,
  ADD_EMPLOYEE_GROUP as ADD_EMPLOYEE_GROUP_API,
  EDIT_EMPLOYEE_GROUP as EDIT_EMPLOYEE_GROUP_API,
  DELETE_EMPLOYEE_GROUP as DELETE_EMPLOYEE_GROUP_API,
} from "../constants/api";

// Get Employee Groups
function* getEmployeeGroup(action) {
  try {
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: true });
    const response = yield call(GET_EMPLOYEE_GROUP_API, action.payload);
    yield put({ type: GET_EMPLOYEE_GROUP, payload: response.data });
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  } catch (error) {
    console.error("Error fetching employee groups:", error);
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  }
}

// Fetch Single Employee Group
function* fetchEmployeeGroup(action) {
  try {
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: true });
    const response = yield call(FETCH_EMPLOYEE_GROUP_API, action.payload);
    yield put({ type: FETCH_EMPLOYEE_GROUP, payload: response.data });
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  } catch (error) {
    console.error("Error fetching employee group:", error);
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  }
}

// Add Employee Group
function* addEmployeeGroup(action) {
  try {
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: true });
    const response = yield call(ADD_EMPLOYEE_GROUP_API, action.payload);
    
    // Refresh the list after successful creation
    yield put({ type: SG_GET_EMPLOYEE_GROUP });
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  } catch (error) {
    console.error("Error adding employee group:", error);
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  }
}

// Edit Employee Group
function* editEmployeeGroup(action) {
  try {
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: true });
    const response = yield call(EDIT_EMPLOYEE_GROUP_API, action.payload);
    
    // Refresh the list after successful edit
    yield put({ type: SG_GET_EMPLOYEE_GROUP });
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  } catch (error) {
    console.error("Error editing employee group:", error);
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  }
}

// Delete Employee Group
function* deleteEmployeeGroup(action) {
  try {
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: true });
    yield call(DELETE_EMPLOYEE_GROUP_API, action.payload);
    
    // Refresh the list after successful deletion
    yield put({ type: SG_GET_EMPLOYEE_GROUP });
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  } catch (error) {
    console.error("Error deleting employee group:", error);
    yield put({ type: PENDING_EMPLOYEE_GROUP, payload: false });
  }
}

export default function* EmployeeGroupSaga() {
  yield takeEvery(SG_GET_EMPLOYEE_GROUP, getEmployeeGroup);
  yield takeEvery(SG_FETCH_EMPLOYEE_GROUP, fetchEmployeeGroup);
  yield takeEvery(SG_ADD_EMPLOYEE_GROUP, addEmployeeGroup);
  yield takeEvery(SG_EDIT_EMPLOYEE_GROUP, editEmployeeGroup);
  yield takeEvery(SG_DELETE_EMPLOYEE_GROUP, deleteEmployeeGroup);
}